import { render, unmountComponentAtNode } from 'react-dom';
import PjaxWrapper from '../utils/PjaxWrapper';
import Footer from '../components/Footer/Footer';

function run(footerElement, config) {
	const element = document.getElementById(footerElement);

	if (element) {
		render(<Footer config={config} />, element);
		PjaxWrapper.addUnloadFunc(() => {
			unmountComponentAtNode(element);
		});
	}
}

export { run };
